import Vue from "vue"
import store from "./store"
import Layout from './components/layout'
import router from "./router"
import element from './utils/element'
import zeroTree from './utils/zero-tree'

import { MessageBox } from 'element-ui'
Vue.prototype.$confirm = MessageBox.confirm
Vue.use(element)
Vue.use(zeroTree)

import 'normalize.css' // 重置样式
import './assets/font/iconfont.css' // 引入字体样式
import './assets/style/global.css' // 全局样式

// 自动聚焦
Vue.directive('focus', function(el) {
  el.querySelector('input,textarea').focus()
})

// 全局注册loading组件
import myLoading from '@/plugins/loading'
Vue.use(myLoading)

import '@/permission' // 页面权限控制模块

const isDev = process.env.NODE_ENV !== 'production'
Vue.config.debug = isDev
Vue.config.devtools = isDev
Vue.config.productionTip = isDev

import { $BASE_URL } from './utils/env'
store.dispatch('setBaseUrlAnsy', $BASE_URL.replace('api',''))
Vue.prototype.$cookiesDomain = '.51jiaoxi.com'

new Vue({
  router,
  store,
  data: {
    Bus: new Vue(), // 组件通信Bus
  },
  render: h => h(Layout)
}).$mount("#app");
